var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBox1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 7.99992C1.33301 4.85722 1.33301 3.28587 2.30932 2.30956C3.28563 1.33325 4.85698 1.33325 7.99967 1.33325C11.1424 1.33325 12.7137 1.33325 13.69 2.30956C14.6663 3.28587 14.6663 4.85722 14.6663 7.99992C14.6663 11.1426 14.6663 12.714 13.69 13.6903C12.7137 14.6666 11.1424 14.6666 7.99967 14.6666C4.85698 14.6666 3.28563 14.6666 2.30932 13.6903C1.33301 12.714 1.33301 11.1426 1.33301 7.99992Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66626 8.33325L6.99959 9.66659L10.3329 6.33325",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox1);
export default __webpack_public_path__ + "static/media/checkBox1.cea1530716e24207302ca0bf8a9e3e59.svg";
export { ForwardRef as ReactComponent };